module.exports = __webpack_public_path__ + "img/main.e936a278.png";